import React from "react";
import { useParams } from "react-router-dom";
import { makeStyles } from "@mui/styles";
import { useNavigate } from "react-router-dom";

const useStyles = makeStyles({
  bottomTerm: {
    padding: "38px 0",
    display: "flex",
    justifyContent: "center",
  },
  innerTerm: {
    width: 285,
    fontFamily: "Roboto",
    fontSize: "16px",
    textAlign: "center",
  },
  likeLink: {
    textDecoration: "underline",
  },
});

const Agreement = (props) => {
  const { merchantId } = useParams();
  const { textColor = "#fff" } = props;
  const classes = useStyles();
  const navigate = useNavigate();

  return (
    <div className={classes.bottomTerm}>
      <div className={classes.innerTerm} style={{ color: textColor }}>
        By joining in, you agree to MenuSifu. Inc{" "}
        <span
          style={{ color: textColor }}
          className={classes.likeLink}
          onClick={() => navigate(`/term_of_service`)}
        >
          Terms of Service
        </span>
        &nbsp; and &nbsp;
        <span
          style={{ color: textColor }}
          className={classes.likeLink}
          onClick={() => navigate(`/privacy_policy`)}
        >
          Privacy Policy
        </span>
      </div>
    </div>
  );
};

export default Agreement;
